import React from 'react';

import Row from 'components/Common/Row';
import Inputs from 'components/Inputs';
import Typography from 'kingpin/atoms/Typography';

// Lets a gadget ignore its dashboard's filters (its default, quick and
// run-time filters)
const IgnoreDashboardFiltersToggle = ({
  isDashboardFiltersIgnored,
  setIsDashboardFiltersIgnored,
}: {
  isDashboardFiltersIgnored: boolean;
  setIsDashboardFiltersIgnored: React.Dispatch<React.SetStateAction<boolean>>;
}) => (
  <Row centerAlign>
    <div style={{ marginRight: 8 }}>
      <Inputs.Toggle
        value={isDashboardFiltersIgnored}
        onChange={setIsDashboardFiltersIgnored}
        testId="ignore-dashboard-filters"
      />
    </div>
    <Typography.Body type="Label">Ignore dashboard filters</Typography.Body>
  </Row>
);

export default IgnoreDashboardFiltersToggle;
